// extracted by mini-css-extract-plugin
module.exports = {"account_icon":"Icons_account_icon__s6Unj","wishlist_icon":"Icons_wishlist_icon__a18JP","cart_icon":"Icons_cart_icon__w64UO"};